// Copyright (c) 2025. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import './ImageQualityBanner.scss';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

export default function ImageQualityBanner({ hasIssues, selectedCount, total, issues, allAffectedBalesUnselected }) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = React.useState(true);

  if (!hasIssues) return null;

  return (
    <>
      {isExpanded ? (
        <div
          className={`delivery-image-view--quality-banner ${allAffectedBalesUnselected ? 'collapsed' : ''}`}
          onClick={() => setIsExpanded(false)}
        >
          <div className='delivery-image-view--quality-banner-content'>
            <div className='delivery-image-view--quality-banner-icon'>
              <AlertTriangle size={18} />
            </div>
            <div className='delivery-image-view--quality-banner-info'>
              <div className='delivery-image-view--quality-banner-title'>{t('image_quality_warning')}</div>
              <div className='delivery-image-view--quality-banner-details'>
                <span className='delivery-image-view--quality-banner-count'>
                  {t('bales_selected_with_issues', { count: selectedCount, total })}
                </span>
                <span className='delivery-image-view--quality-banner-issues'>{issues.join(', ')}</span>
              </div>
            </div>
          </div>
          <div className='delivery-image-view--quality-banner-action'>
            <span className='delivery-image-view--quality-banner-suggestion'>{t('quality_issues_suggestion')}</span>
          </div>
        </div>
      ) : (
        <div className='delivery-image-view--quality-banner-hidden' onClick={() => setIsExpanded(true)}>
          <div className='delivery-image-view--quality-banner-icon'>
            <AlertTriangle size={18} />
          </div>
        </div>
      )}
    </>
  );
}
